import { network } from 'services/network';

export const bulkRollbackInterimStatus = (params) => {
    return network.post('api/bo/bulkRollbackInterimStatus', params).then((response) => {
        return response.data;
    });
};
